export function readOperatorIdFromToken(token: string): string | null {
  const payload = token.split(".")[1];
  if (payload === undefined || payload.length === 0) return null;
  try {
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - normalized.length % 4) % 4);
    const parsed: unknown = JSON.parse(atob(`${normalized}${padding}`));
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) return null;
    const claims = parsed as Readonly<Record<string, unknown>>;
    if (claims.tokenUse !== "operator_access" || typeof claims.sub !== "string") return null;
    const operatorId = claims.sub.trim();
    return operatorId.length === 0 ? null : operatorId;
  } catch {
    return null;
  }
}
